import { api } from './api';

export interface Tenant {
  id: number;
  name: string;
  domain?: string;
  timezone: string;
  currency: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface TenantCreate {
  name: string;
  domain?: string;
  timezone?: string;
  currency?: string;
}

export interface TenantUpdate {
  name?: string;
  domain?: string;
  timezone?: string;
  currency?: string;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const tenantService = {
  getAll: async (page = 1, limit = 10, search?: string): Promise<PaginatedResponse<Tenant>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    
    const response = await api.get<PaginatedResponse<Tenant>>(`/tenants?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { tenant: Tenant } }> => {
    const response = await api.get<{ data: { tenant: Tenant } }>(`/tenants/${id}`);
    return response.data;
  },

  create: async (data: TenantCreate): Promise<{ data: { tenant: Tenant } }> => {
    const response = await api.post<{ data: { tenant: Tenant } }>('/tenants', data);
    return response.data;
  },

  update: async (id: number, data: TenantUpdate): Promise<{ data: { tenant: Tenant } }> => {
    const response = await api.put<{ data: { tenant: Tenant } }>(`/tenants/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/tenants/${id}`);
  }
};

